import PropTypes from "prop-types";
import Skeleton from "react-loading-skeleton";

import { SwitchContainer, SwitchRoot, SwitchThumb } from "./styles";
import { LabelText } from "../styles";
import { useMemo } from "react";

const Toggle = ({
  id = "",
  value,
  onChange,
  buttonStyle,
  isDisabled = false,
  isLoading = false,
  label,
  labelPosition = "top",
  isReadOnly,
}) => {
  const flexDirection = useMemo(
    () => (labelPosition === "top" ? "column" : "row"),
    [labelPosition]
  );
  const alignItems = useMemo(
    () => (labelPosition === "top" ? "start" : "center"),
    [labelPosition]
  );

  return (
    <div style={{ width: "fit-content" }}>
      <SwitchContainer style={{ flexDirection, alignItems }}>
        {label && <LabelText disabled={isDisabled}>{label}</LabelText>}
        {isLoading ? (
          <Skeleton
            style={{ width: "51px", height: "24px", borderRadius: "9999px" }}
          />
        ) : (
          <SwitchRoot
            id={id}
            disabled={isDisabled}
            isreadonly={String(isReadOnly)}
            checked={value}
            onCheckedChange={onChange}
            style={buttonStyle}
          >
            <SwitchThumb />
          </SwitchRoot>
        )}
      </SwitchContainer>
    </div>
  );
};

Toggle.propTypes = {
  buttonStyle: PropTypes.any,
  id: PropTypes.string,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isReadOnly: PropTypes.any,
  label: PropTypes.any,
  labelPosition: PropTypes.string,
  onChange: PropTypes.any,
  value: PropTypes.any,
};

export default Toggle;
